import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-member-profile-def';

const listDefs = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/defs`, data);
};

const getDef = (merchantId, defKey) => {
	return Client.get(`${baseUrl}/${merchantId}/defs/${defKey}`);
};

const addDef = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/defs`, data);
};

const updateDef = (merchantId, defKey, data) => {
	return Client.put(`${baseUrl}/${merchantId}/defs/${defKey}`, data);
};

const deleteDef = (merchantId, defKey, data) => {
	return Client.del(`${baseUrl}/${merchantId}/defs/${defKey}`, data);
};

export default {
	listDefs,
	getDef,
	addDef,
	updateDef,
	deleteDef,
};
